var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayBtnWhiteTrans(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 77,
    viewBox: "0 0 264 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M253.945 76.6562H9.7671C4.39764 76.6562 0 72.3419 0 67.0742V9.58203C0 4.31431 4.39764 1.02481e-06 9.7671 1.02481e-06H253.945C259.314 1.02481e-06 263.712 4.31431 263.712 9.58203V67.0742C263.712 72.3419 259.314 76.6562 253.945 76.6562Z",
    fill: "url(#paint0_linear_569_10138)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M253.945 1.53552C258.467 1.53552 262.146 5.14555 262.146 9.58203V67.0742C262.146 71.5107 258.467 75.1207 253.945 75.1207H9.7671C5.24493 75.1207 1.56518 71.5107 1.56518 67.0742V9.58203C1.56518 5.14555 5.24493 1.53552 9.7671 1.53552H253.945ZM253.945 1.02481e-06H9.7671C4.39764 1.02481e-06 0 4.31431 0 9.58203V67.0742C0 72.3419 4.39764 76.6562 9.7671 76.6562H253.945C259.314 76.6562 263.712 72.3419 263.712 67.0742V9.58203C263.712 4.31431 259.314 1.02481e-06 253.945 1.02481e-06Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6263 19.6313C92.6263 21.2315 92.1379 22.5131 91.1759 23.4689C90.0698 24.602 88.6291 25.1721 86.8637 25.1721C85.1764 25.1721 83.7358 24.5924 82.554 23.4497C81.3697 22.2903 80.7788 20.8674 80.7788 19.1642C80.7788 17.461 81.3697 16.038 82.554 14.8882C83.7358 13.736 85.1764 13.1562 86.8637 13.1562C87.7037 13.1562 88.5046 13.3263 89.2689 13.6425C90.0307 13.9611 90.6509 14.3923 91.1002 14.9241L90.0795 15.935C89.2957 15.0271 88.2287 14.5792 86.8637 14.5792C85.6331 14.5792 84.566 15.0008 83.6601 15.8512C82.764 16.704 82.3147 17.8083 82.3147 19.1642C82.3147 20.52 82.764 21.6339 83.6601 22.4867C84.566 23.3276 85.6331 23.7588 86.8637 23.7588C88.1701 23.7588 89.2689 23.3276 90.1357 22.4772C90.7071 21.9142 91.0318 21.1381 91.1173 20.1463H86.8637V18.7617H92.5384C92.6068 19.0612 92.6263 19.351 92.6263 19.6313Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.631 14.8299H96.3005V18.4711H101.106V19.8557H96.3005V23.4968H101.631V24.9078H94.7915V13.4189H101.631V14.8299Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.982 24.9078H106.473V14.8299H103.203V13.4189H111.254V14.8299H107.982V24.9078Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.08 24.9078V13.4189H118.587V24.9078H117.08Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125.263 24.9078H123.767V14.8299H120.485V13.4189H128.545V14.8299H125.263V24.9078Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M143.79 23.4306C142.635 24.5924 141.204 25.1721 139.497 25.1721C137.78 25.1721 136.35 24.5924 135.195 23.4306C134.042 22.2712 133.468 20.8482 133.468 19.1642C133.468 17.4801 134.042 16.0572 135.195 14.8978C136.35 13.736 137.78 13.1562 139.497 13.1562C141.194 13.1562 142.625 13.736 143.78 14.9074C144.942 16.0764 145.516 17.4897 145.516 19.1642C145.516 20.8482 144.942 22.2712 143.79 23.4306ZM136.31 22.4676C137.18 23.3276 138.237 23.7588 139.497 23.7588C140.747 23.7588 141.814 23.3276 142.674 22.4676C143.541 21.6076 143.98 20.5033 143.98 19.1642C143.98 17.8251 143.541 16.7208 142.674 15.8608C141.814 15.0008 140.747 14.5696 139.497 14.5696C138.237 14.5696 137.18 15.0008 136.31 15.8608C135.444 16.7208 135.004 17.8251 135.004 19.1642C135.004 20.5033 135.444 21.6076 136.31 22.4676Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M147.632 24.9078V13.4189H149.464L155.158 22.3542H155.224L155.158 20.1455V13.4189H156.664V24.9078H155.092L149.129 15.5318H149.063L149.129 17.75V24.9078H147.632Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M133.095 41.6869C128.507 41.6869 124.759 45.1125 124.759 49.8389C124.759 54.5269 128.507 57.9884 133.095 57.9884C137.693 57.9884 141.441 54.5269 141.441 49.8389C141.441 45.1125 137.693 41.6869 133.095 41.6869ZM133.095 54.7784C130.578 54.7784 128.412 52.7398 128.412 49.8389C128.412 46.8996 130.578 44.8969 133.095 44.8969C135.613 44.8969 137.788 46.8996 137.788 49.8389C137.788 52.7398 135.613 54.7784 133.095 54.7784ZM114.907 41.6869C110.309 41.6869 106.57 45.1125 106.57 49.8389C106.57 54.5269 110.309 57.9884 114.907 57.9884C119.502 57.9884 123.243 54.5269 123.243 49.8389C123.243 45.1125 119.502 41.6869 114.907 41.6869ZM114.907 54.7784C112.387 54.7784 110.214 52.7398 110.214 49.8389C110.214 46.8996 112.387 44.8969 114.907 44.8969C117.424 44.8969 119.59 46.8996 119.59 49.8389C119.59 52.7398 117.424 54.7784 114.907 54.7784ZM93.2627 44.1855V47.6494H101.694C101.448 49.5849 100.788 51.0079 99.7774 51.9996C98.5467 53.1974 96.6299 54.5269 93.2627 54.5269C88.0739 54.5269 84.0108 50.4186 84.0108 45.3281C84.0108 40.2377 88.0739 36.1294 93.2627 36.1294C96.0683 36.1294 98.1096 37.2049 99.6162 38.5991L102.104 36.1581C99.9971 34.1842 97.194 32.6679 93.2627 32.6679C86.1474 32.6679 80.1675 38.3476 80.1675 45.3281C80.1675 52.3086 86.1474 57.9884 93.2627 57.9884C97.1085 57.9884 99.9971 56.7523 102.268 54.4334C104.595 52.1505 105.32 48.9405 105.32 46.3486C105.32 45.5437 105.252 44.8035 105.13 44.1855H93.2627ZM181.767 46.8708C181.081 45.0478 178.964 41.6869 174.652 41.6869C170.379 41.6869 166.821 44.9903 166.821 49.8389C166.821 54.4047 170.342 57.9884 175.062 57.9884C178.879 57.9884 181.081 55.7054 181.987 54.3759L179.155 52.5242C178.21 53.8801 176.923 54.7784 175.062 54.7784C173.214 54.7784 171.888 53.9471 171.038 52.3086L182.151 47.7979L181.767 46.8708ZM170.437 49.5849C170.342 46.442 172.926 44.8322 174.776 44.8322C176.227 44.8322 177.458 45.5437 177.868 46.5618L170.437 49.5849ZM161.405 57.4925H165.058V33.5374H161.405V57.4925ZM155.423 43.5027H155.301C154.48 42.5493 152.915 41.6869 150.933 41.6869C146.772 41.6869 142.967 45.2706 142.967 49.8652C142.967 54.4334 146.772 57.9884 150.933 57.9884C152.915 57.9884 154.48 57.1188 155.301 56.1366H155.423V57.3056C155.423 60.4222 153.726 62.0967 150.989 62.0967C148.757 62.0967 147.372 60.5156 146.801 59.1861L143.624 60.4869C144.54 62.6476 146.965 65.3066 150.989 65.3066C155.272 65.3066 158.885 62.8345 158.885 56.8194V42.1828H155.423V43.5027ZM151.245 54.7784C148.728 54.7784 146.62 52.7111 146.62 49.8652C146.62 46.993 148.728 44.8969 151.245 44.8969C153.726 44.8969 155.682 46.993 155.682 49.8652C155.682 52.7111 153.726 54.7784 151.245 54.7784ZM198.869 33.5374H190.133V57.4925H193.776V48.4159H198.869C202.915 48.4159 206.883 45.5437 206.883 40.9755C206.883 36.4096 202.906 33.5374 198.869 33.5374ZM198.965 45.0838H193.776V36.8696H198.965C201.685 36.8696 203.238 39.0854 203.238 40.9755C203.238 42.8296 201.685 45.0838 198.965 45.0838ZM221.485 41.6414C218.853 41.6414 216.116 42.7817 214.99 45.3089L218.223 46.6385C218.919 45.3089 220.198 44.8778 221.551 44.8778C223.441 44.8778 225.358 45.9917 225.387 47.9584V48.2099C224.728 47.8362 223.316 47.2828 221.58 47.2828C218.098 47.2828 214.55 49.1633 214.55 52.6727C214.55 55.8827 217.402 57.95 220.609 57.95C223.06 57.95 224.413 56.8649 225.263 55.6024H225.387V57.4542H228.906V48.265C228.906 44.0178 225.673 41.6414 221.485 41.6414ZM221.046 54.7688C219.854 54.7688 218.194 54.1891 218.194 52.7398C218.194 50.8857 220.264 50.1742 222.057 50.1742C223.661 50.1742 224.413 50.5216 225.387 50.9791C225.101 53.1974 223.155 54.7688 221.046 54.7688ZM241.725 42.166L237.537 52.5506H237.413L233.084 42.166H229.155L235.66 56.678L231.948 64.7533H235.755L245.778 42.166H241.725ZM208.886 57.4925H212.538V33.5374H208.886V57.4925Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3834 14.448C19.8096 15.0373 19.4775 15.9548 19.4775 17.143V59.5243C19.4775 60.7125 19.8096 61.63 20.3834 62.2193L20.5251 62.3486L44.7328 38.6091V38.0486L20.5251 14.3091L20.3834 14.448Z",
    fill: "url(#paint1_linear_569_10138)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7966 46.5244L44.7363 38.6073V38.0467L52.8064 30.1296L52.9871 30.2326L62.5442 35.5674C65.2716 37.0813 65.2716 39.5727 62.5442 41.0962L52.9871 46.4214L52.7966 46.5244Z",
    fill: "url(#paint2_linear_569_10138)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9844 46.422L44.7336 38.3276L20.3843 62.218C21.2902 63.1523 22.7674 63.2649 24.4474 62.3306L52.9844 46.422Z",
    fill: "url(#paint3_linear_569_10138)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9844 30.2337L24.4474 14.3251C22.7674 13.4005 21.2902 13.5131 20.3843 14.4473L44.7336 38.3281L52.9844 30.2337Z",
    fill: "url(#paint4_linear_569_10138)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_569_10138",
    x1: 131.856,
    y1: 76.6562,
    x2: 131.856,
    y2: 0.00000102481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61BE7A",
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_569_10138",
    x1: 42.5835,
    y1: 59.9657,
    x2: 10.4274,
    y2: 27.1886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_569_10138",
    x1: 66.0958,
    y1: 38.3243,
    x2: 18.8291,
    y2: 38.3243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_569_10138",
    x1: 48.4979,
    y1: 33.9274,
    x2: 4.89172,
    y2: -10.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_569_10138",
    x1: 14.255,
    y1: 76.3186,
    x2: 33.7271,
    y2: 56.4706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBtnWhiteTrans);
export default __webpack_public_path__ + "static/media/play-btn-white-trans.02bcd57426a21794054d3ea9b5dcf4dd.svg";
export { ForwardRef as ReactComponent };